import axios from 'axios'
import {
  PaginatedPaymentTasksResponseSchema,
  PaymentDetailSchema,
} from './schema'

export interface UsePaymentTasksParams {
  page?: number
  perPage?: number
  globalOnId?: number
  search?: string
  programId?: number
}

export const fetchPaymentTasks = async ({
  page = 1,
  perPage = 10,
  globalOnId = 1,
  search,
  programId,
}: UsePaymentTasksParams) => {
  const response = await axios.get(`/payment_tasks`, {
    params: {
      paginate: 1,
      per_page: perPage,
      page,
      global_on_id: globalOnId,
      search,
      program_id: programId,
    },
  })

  return PaginatedPaymentTasksResponseSchema.parse(response.data)
}

export interface UsePaymentDetailsParams {
  programId?: number
  paymentId?: string
}

export const fetchPaymentDetail = async ({
  programId,
  paymentId,
}: UsePaymentDetailsParams) => {
  const response = await axios.get(`payments/${paymentId}`, {
    params: {
      program_id: programId,
    },
  })
  console.log(PaymentDetailSchema.safeParse(response.data).error)
  return PaymentDetailSchema.parse(response.data)
}
